import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Account } from 'C4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const resetScrollPosition = () => window.scrollTo(0, 0);

const UserWidget = (props) => {
  const {
    loggedIn,
    firstName,
    accountToggle,
    handleAccountToggle,
    unreadMessageCount,
  } = props;

  return (
    <div className="userWidget">
      <ul>
        <li className={loggedIn ? '' : 'disabled'}>
          <NavLink onClick={resetScrollPosition} activeClassName="is-active" id="searchBtn1" to="/main/search">
            <FontAwesomeIcon icon={['fas', 'search']} />
          </NavLink>
        </li>
        <li className={loggedIn ? '' : 'disabled'}>
          <NavLink onClick={resetScrollPosition} activeClassName="is-active" id="messageBtn1" to="/main/favorites">
            <FontAwesomeIcon icon={['fas', 'heart']} />
          </NavLink>
        </li>
        <li>
          <Account
            onClick={handleAccountToggle}
            firstName={firstName}
            expanded={accountToggle}
            loggedIn={loggedIn}
          />
        </li>
      </ul>
    </div>
  );
};

export default UserWidget;

UserWidget.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  firstName: PropTypes.string.isRequired,
  accountToggle: PropTypes.bool.isRequired,
  handleAccountToggle: PropTypes.func.isRequired,
  unreadMessageCount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

UserWidget.defaultProps = {
  unreadMessageCount: '',
};
